// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputText_inputContainerGlobal__4dQn7 {
  display: flex;
  height: 80px;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
}
.InputText_inputContainer__H9pYY {
  box-sizing: border-box;
  display: flex;
  height: auto;
  flex-direction: column;
  align-items: flex-start;

  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #f8fafc;
  border-width: 1px;
  border-style: solid;
  border-radius: 12px;
  border-color: gray;
}

.InputText_focused__1QDwD {
  border-width: 2px;
  border-color: black;

  padding-left: 14px;
  padding-right: 14px;
  padding-top: 9px;
  padding-bottom: 9px;
  margin-top: 0px;
}

.InputText_inputContainerConError__bIixc {
  border-width: 2px;
  border-color: red;
}

label {
  color: gray;
  font-size: 0.8rem;
  margin-left: 2px;
}
input {
  background-color: #f8fafc;

  border-width: 0px;
  height: 35px;
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
  color: black;
}

input:focus {
  outline: none; /* Elimina el contorno que aparece al enfocar */
  border: none; /* Elimina el borde */
  /* Opcionalmente, puedes añadir un estilo personalizado si deseas */
  box-shadow: none; /* Si deseas eliminar también cualquier sombra */
}
input:active {
  border-width: 0px;
}

.InputText_mensajeError__iMVKy {
  color: red;
  height: 25px;
  width: auto;
  text-align: left;
  padding-left: 20px;
}

.InputText_divIconoPassword__Bll3K {
  display: flex;
  height: 30px;
  width: 30px;
}

@media (min-width: 768px) {
  .InputText_inputContainer__H9pYY {
    height: 66px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InputText/InputText.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;;EAEnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;;EAEzB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa,EAAE,+CAA+C;EAC9D,YAAY,EAAE,qBAAqB;EACnC,mEAAmE;EACnE,gBAAgB,EAAE,gDAAgD;AACpE;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".inputContainerGlobal {\n  display: flex;\n  height: 80px;\n  flex-direction: column;\n  align-content: flex-start;\n  justify-content: flex-start;\n}\n.inputContainer {\n  box-sizing: border-box;\n  display: flex;\n  height: auto;\n  flex-direction: column;\n  align-items: flex-start;\n\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  background-color: #f8fafc;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 12px;\n  border-color: gray;\n}\n\n.focused {\n  border-width: 2px;\n  border-color: black;\n\n  padding-left: 14px;\n  padding-right: 14px;\n  padding-top: 9px;\n  padding-bottom: 9px;\n  margin-top: 0px;\n}\n\n.inputContainerConError {\n  border-width: 2px;\n  border-color: red;\n}\n\nlabel {\n  color: gray;\n  font-size: 0.8rem;\n  margin-left: 2px;\n}\ninput {\n  background-color: #f8fafc;\n\n  border-width: 0px;\n  height: 35px;\n  width: 100%;\n  font-size: 1rem;\n  font-weight: 500;\n  color: black;\n}\n\ninput:focus {\n  outline: none; /* Elimina el contorno que aparece al enfocar */\n  border: none; /* Elimina el borde */\n  /* Opcionalmente, puedes añadir un estilo personalizado si deseas */\n  box-shadow: none; /* Si deseas eliminar también cualquier sombra */\n}\ninput:active {\n  border-width: 0px;\n}\n\n.mensajeError {\n  color: red;\n  height: 25px;\n  width: auto;\n  text-align: left;\n  padding-left: 20px;\n}\n\n.divIconoPassword {\n  display: flex;\n  height: 30px;\n  width: 30px;\n}\n\n@media (min-width: 768px) {\n  .inputContainer {\n    height: 66px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainerGlobal": `InputText_inputContainerGlobal__4dQn7`,
	"inputContainer": `InputText_inputContainer__H9pYY`,
	"focused": `InputText_focused__1QDwD`,
	"inputContainerConError": `InputText_inputContainerConError__bIixc`,
	"mensajeError": `InputText_mensajeError__iMVKy`,
	"divIconoPassword": `InputText_divIconoPassword__Bll3K`
};
export default ___CSS_LOADER_EXPORT___;
